var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSvnFlag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 45,
    viewBox: "0 0 60 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_59_65000)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M-4.12744 0H85.8726V45H-4.12744V0Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M-4.12744 29.9971H85.8726V45H-4.12744V29.9971Z",
    fill: "#D50000"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M-4.12744 15.0029H85.8726V29.9971H-4.12744V15.0029Z",
    fill: "#0000BF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.396 8.17383C21.0444 13.5879 20.8335 16.5586 20.0161 17.9297C19.1196 19.4062 18.2583 20.4873 14.769 21.7969C11.2886 20.4873 10.4272 19.4062 9.53076 17.9297C8.70459 16.5586 8.50244 13.5879 8.15088 8.17383L8.66064 7.99805C9.69775 7.68164 10.4712 7.42676 11.0425 7.3125C11.8599 7.13672 12.563 6.94336 14.7603 6.89941C16.9575 6.93457 17.6606 7.14551 18.478 7.32129C19.0405 7.44434 19.8491 7.67285 20.8774 7.99805L21.396 8.17383Z",
    fill: "#D50000"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.8862 7.99805C20.5522 13.4033 20.271 15.8818 19.8315 17.0684C18.9878 19.1074 17.6519 20.2236 14.769 21.2871C11.8862 20.2236 10.5503 19.1074 9.69775 17.0684C9.2583 15.873 8.99463 13.4033 8.66064 7.98926C9.68018 7.67285 10.4712 7.42676 11.0425 7.3125C11.8599 7.13672 12.563 6.93457 14.7603 6.89941C16.9575 6.93457 17.6606 7.13672 18.478 7.3125C19.2916 7.4977 20.0953 7.72357 20.8862 7.98926V7.99805Z",
    fill: "#0000BF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.769 9.65039L14.9009 9.97559L15.5161 10.0635L15.1206 10.3008L15.4985 10.5557L14.9448 10.6436L14.769 10.9424L14.5933 10.6348L14.0659 10.5645L14.4175 10.3008L14.0483 10.0635L14.6372 9.97559L14.769 9.65039Z",
    fill: "#FFDF00"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.6294 15.7852L19.2866 15.5215L19.0493 15.1172L18.5747 14.7041L18.3198 14.291L17.8452 13.8604L17.6167 13.4473L17.353 13.2451L17.1948 13.0781L16.7554 13.4561L16.5269 13.8691L16.2368 14.1328L15.9116 13.8779L15.6743 13.4561L14.769 11.8477L13.8638 13.4561L13.6265 13.8779L13.3013 14.1328L13.0112 13.8691L12.7739 13.4561L12.3433 13.0781L12.1763 13.2363L11.9214 13.4473L11.6929 13.8604L11.2183 14.291L10.9634 14.7041L10.4888 15.1172L10.2515 15.5215L9.90869 15.7852C10.1019 16.9949 10.6744 18.1121 11.5435 18.9756C12.4863 19.7825 13.5796 20.3949 14.7603 20.7773C15.9499 20.4034 17.0506 19.7903 17.9946 18.9756C18.5044 18.4482 19.4536 17.2793 19.6294 15.7852Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.2104 7.37402L16.3511 7.69922L16.9663 7.78711L16.562 8.02441L16.9487 8.2793L16.395 8.36719L16.2192 8.66602L16.0435 8.3584L15.5161 8.28809L15.8677 8.02441L15.4985 7.78711L16.0786 7.69922L16.2192 7.37402H16.2104ZM13.3101 7.37402L13.4507 7.69922L14.0659 7.77832L13.6704 8.01562L14.0483 8.27051L13.4946 8.3584L13.3188 8.65723L13.1431 8.3584L12.6157 8.2793L12.9673 8.01562L12.5981 7.77832L13.187 7.69043L13.3188 7.36523L13.3101 7.37402Z",
    fill: "#FFDF00"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.8735 17.8418H18.2231L17.6079 17.7979L16.8784 17.4463H16.0522L15.3403 17.7979L14.769 17.8506L14.2065 17.7979L13.4946 17.4463H12.6597L11.9214 17.7979L11.3149 17.8506L10.647 17.8418L10.3306 17.2969L10.3394 17.2793L11.3237 17.4463L11.9302 17.4023L12.6597 17.042H13.4858L14.2065 17.3936L14.769 17.4463L15.3403 17.3936L16.0522 17.042H16.8784L17.6167 17.3936L18.2231 17.4463L19.1724 17.2705L19.1899 17.3057L18.8647 17.8418H18.8735ZM11.2798 18.6768L11.9302 18.6328L12.6597 18.2813H13.4858L14.2065 18.6328L14.769 18.6768L15.3315 18.6328L16.0522 18.2813H16.8784L17.6079 18.6328L18.2671 18.6768L18.689 18.1494H18.6802L18.2231 18.2725L17.6167 18.2285L16.8872 17.877H16.061L15.3403 18.2285L14.7778 18.2813L14.2065 18.2285L13.4946 17.877H12.6597L11.9214 18.2285L11.3149 18.2813L10.8755 18.167V18.1846L11.271 18.6768H11.2798Z",
    fill: "#0000BF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_59_65000"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 45,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSvnFlag);
export default __webpack_public_path__ + "static/media/svn-flag.1d26facb9378cd7e4c3dbc17b49b6d73.svg";
export { ForwardRef as ReactComponent };